export class OrderDocumentTypeResModel {
  name: string;
  code: string;
}
